import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20Korean%20manhwa%20themed%20background%20with%20soft%20watercolor%20ink%20wash%20style%2C%20warm%20cream%20and%20coral%20tones%2C%20abstract%20comic%20panel%20elements%20floating%2C%20dreamy%20atmosphere%2C%20subtle%20golden%20accents%2C%20artistic%20composition%2C%20no%20text&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="韩漫之家 - 免费韩国漫画在线阅读"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/25 to-foreground-950/60"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 w-full">
        <div className="max-w-3xl">
          <p className="text-accent-400 text-sm md:text-base font-medium tracking-wider mb-4 animate-fade-in">
            最新高清免费韩国漫画大全
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
            热门韩漫在线阅读
            <span className="block text-accent-400 text-xl md:text-2xl lg:text-3xl mt-2 font-body font-normal">
              您的可靠韩漫阅读选择
            </span>
          </h1>
          <p className="text-background-200 text-sm md:text-base max-w-lg mx-auto mb-8 leading-relaxed">
            海量高清韩国漫画，每日更新，免费畅读。恋爱、奇幻、动作、悬疑等丰富分类，满足您的所有阅读需求。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
            >
              立即阅读
              <span className="ml-2">
                <div className="w-4 h-4 inline-flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </span>
            </Link>
            <Link
              to="/about"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="w-full sm:w-auto px-8 py-3 border border-background-300/50 text-background-50 font-medium rounded-full hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}